import React, { useState, useEffect, useCallback } from "react";
import { ArrowRight, X, ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
const projects = [{
  id: "RD01",
  specs: "Villa Urquiza",
  images: [{
    url: "https://rudichgroup.redian.com.ar/wp-content/uploads/2026/05/Mendoza1.jpeg",
    srcset: "https://rudichgroup.redian.com.ar/wp-content/uploads/2026/05/Mendoza1.jpeg",
    sizes: "https://rudichgroup.redian.com.ar/wp-content/uploads/2026/05/Mendoza1.jpeg"
  }, {
    url: "https://rudichgroup.redian.com.ar/wp-content/uploads/2026/05/Mendoza2.jpeg",
    srcset: "https://rudichgroup.redian.com.ar/wp-content/uploads/2026/05/Mendoza2.jpeg",
    sizes: "https://rudichgroup.redian.com.ar/wp-content/uploads/2026/05/Mendoza2.jpeg"
  }, {
    url: "https://rudichgroup.redian.com.ar/wp-content/uploads/2026/05/Mendoza3.jpeg",
    srcset: "https://rudichgroup.redian.com.ar/wp-content/uploads/2026/05/Mendoza3.jpeg",
    sizes: "https://rudichgroup.redian.com.ar/wp-content/uploads/2026/05/Mendoza3.jpeg-wvc-sizes"
  }],
  title: "MENDOZA 5601",
  category: "Desarrollo",
  pdfUrl: "https://rudichgroup.redian.com.ar/wp-content/uploads/2026/06/BROCHURE_MENDOZA.pdf"
}, {
  id: "RD02",
  specs: "Recoleta",
  images: [{
    url: "https://rudichgroup.redian.com.ar/wp-content/uploads/2026/05/Uriburu1.png",
    srcset: "https://rudichgroup.redian.com.ar/wp-content/uploads/2026/05/Uriburu1.png",
    sizes: "https://rudichgroup.redian.com.ar/wp-content/uploads/2026/05/Uriburu1.png5-wvc-sizes"
  }, {
    url: "https://rudichgroup.redian.com.ar/wp-content/uploads/2026/05/Uriburu2.png",
    srcset: "https://rudichgroup.redian.com.ar/wp-content/uploads/2026/05/Uriburu2.png",
    sizes: "https://rudichgroup.redian.com.ar/wp-content/uploads/2026/05/Uriburu2.png-wvc-sizes"
  }, {
    url: "https://rudichgroup.redian.com.ar/wp-content/uploads/2026/05/Uriburu3.png",
    srcset: "https://rudichgroup.redian.com.ar/wp-content/uploads/2026/05/Uriburu3.png",
    sizes: "https://rudichgroup.redian.com.ar/wp-content/uploads/2026/05/Uriburu3.png-wvc-sizes"
  }],
  title: "PRESIDENTE JOSÉ EVARISTO URIBURU 1274",
  category: "Inversión",
  pdfUrl: "https://rudichgroup.redian.com.ar/wp-content/uploads/2026/06/BROCHURE_URIBURU.pdf"
}];
export default function SeleccionDeProyectos() {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState<any>(null);
  const [carouselIndices, setCarouselIndices] = useState<Record<string, number>>(projects.reduce((acc, p) => ({
    ...acc,
    [p.id]: 0
  }), {}));
  const [isPaused, setIsPaused] = useState<Record<string, boolean>>(projects.reduce((acc, p) => ({
    ...acc,
    [p.id]: false
  }), {}));
  const nextImage = useCallback((projectId: string) => {
    setCarouselIndices(prev => {
      const project = projects.find(p => p.id === projectId);
      if (!project) return prev;
      const nextIdx = (prev[projectId] + 1) % project.images.length;
      return {
        ...prev,
        [projectId]: nextIdx
      };
    });
  }, []);
  const prevImage = useCallback((projectId: string) => {
    setCarouselIndices(prev => {
      const project = projects.find(p => p.id === projectId);
      if (!project) return prev;
      const prevIdx = (prev[projectId] - 1 + project.images.length) % project.images.length;
      return {
        ...prev,
        [projectId]: prevIdx
      };
    });
  }, []);
  useEffect(() => {
    const intervals = projects.map(project => {
      return setInterval(() => {
        if (!isPaused[project.id]) {
          nextImage(project.id);
        }
      }, 4000);
    });
    return () => intervals.forEach(clearInterval);
  }, [isPaused, nextImage]);
  const openModal = (project: any) => {
    setSelectedProject(project);
    setIsOpen(true);
  };
  const handleManualNav = (projectId: string, action: () => void) => {
    setIsPaused(prev => ({
      ...prev,
      [projectId]: true
    }));
    action();
    setTimeout(() => {
      setIsPaused(prev => ({
        ...prev,
        [projectId]: false
      }));
    }, 10000);
  };
  return <section data-section-id="2741" id="portafolio-de-proyectos" className="py-24 text-white overflow-hidden !bg-[hsl(0,0%,96%)] md:py-32">
      <div className="mx-auto max-w-[1280px] px-6 !text-[hsl(0,0%,96%)] md:px-8">
        <div className="mb-16 flex flex-col items-start justify-between gap-8 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <Badge variant="outline" className="inline-flex items-center justify-center border w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&]:hover:bg-accent [a&]:hover:text-accent-foreground mb-4 border-[#071F33] rounded-lg px-4 py-1 uppercase tracking-widest text-xs font-bold !text-[hsl(203,55%,13%)] dark:aria-invalid:ring-destructive/40">
              Portafolio
            </Badge>
            <h2 className="font-sans text-4xl font-bold uppercase tracking-tighter leading-[0.9] !text-[hsl(42,50%,70%)] md:text-6xl lg:text-7xl">
              Proyectos <br />
              <span className="text-[#071F33]">Destacados</span>
            </h2>
          </div>
          <div className="flex flex-col items-start gap-4 md:items-end">
            <p className="max-w-xs font-serif text-lg !text-[hsl(203,55%,13%)] md:text-right">
              Explora nuestra selección de desarrollos inmobiliarios de alta gama en las zonas más exclusivas.
            </p>
            <Button asChild className="bg-[#e6cd93] text-white hover:bg-[#e6cd93]/90 rounded-lg px-8 py-6 text-sm font-bold uppercase tracking-widest">
              
            </Button>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-12 md:grid-cols-2">
          {projects.map((project, i) => {
          const currentIndex = carouselIndices[project.id];
          const currentImage = project.images[currentIndex];
          return <div key={project.id} data-index={i} className="group relative flex flex-col gap-6 rounded-2xl shadow-md">
                <div className="relative aspect-[4/5] w-full overflow-hidden rounded-2xl bg-[#0F2533]">
                  <img src={currentImage.url} data-wvc-srcset={currentImage.srcset} data-wvc-sizes={currentImage.sizes} alt={project.title} loading="lazy" className="h-full w-full object-cover transition-all duration-700 ease-out brightness-95 contrast-105 group-hover:scale-105" />
                  
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0F2533]/80 via-transparent to-transparent opacity-60 transition-opacity duration-500 group-hover:opacity-40" />
                  
                  {}
                  <div className="absolute inset-0 flex items-center justify-between px-4 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                    <Button variant="ghost" size="icon" onClick={() => handleManualNav(project.id, () => prevImage(project.id))} className="h-10 w-10 rounded-lg bg-black/20 text-white backdrop-blur-sm hover:bg-black/40">
                      <ChevronLeft className="h-6 w-6" />
                    </Button>
                    <Button variant="ghost" size="icon" onClick={() => handleManualNav(project.id, () => nextImage(project.id))} className="h-10 w-10 rounded-lg bg-black/20 text-white backdrop-blur-sm hover:bg-black/40">
                      <ChevronRight className="h-6 w-6" />
                    </Button>
                  </div>

                  {}
                  <div className="absolute bottom-6 left-1/2 flex -translate-x-1/2 gap-2">
                    {project.images.map((_, idx) => <Button key={idx} variant="ghost" size="icon" onClick={() => handleManualNav(project.id, () => setCarouselIndices(prev => ({
                  ...prev,
                  [project.id]: idx
                })))} className={`h-1.5 min-w-0 p-0 rounded-lg transition-all duration-300 ${idx === currentIndex ? "w-6 bg-[#e6cd93]" : "w-1.5 bg-white/50 hover:bg-white"}`} aria-label={`Go to image ${idx + 1}`} />)}
                  </div>
                </div>

                <div className="flex flex-col gap-4">
                  <div className="flex flex-col gap-2">
                    <h3 className="font-sans text-2xl font-bold uppercase tracking-tight group-hover:text-[#e6cd93] transition-colors duration-300 !text-[hsl(203,55%,13%)]">
                      {project.title}
                    </h3>
                    <div className="flex items-center gap-3 text-white/60">
                      <div className="h-px w-8 !bg-[hsl(207,76%,11%)]" />
                      <p className="font-serif text-sm italic !text-[hsl(203,55%,13%)]">
                        {project.specs}
                      </p>
                    </div>
                  </div>
                  
                  <div className="flex flex-col md:flex-row gap-2">
                    <Button onClick={() => openModal(project)} className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive h-9 has-[>svg]:px-3 text-[#0F2533] font-semibold rounded-lg px-6 py-2 transition-opacity shadow-md w-full !bg-[hsl(42,50%,70%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90 hover:opacity-90 md:w-auto">
                      Ver brochure
                    </Button>
                    <Button onClick={() => window.open(project.pdfUrl, '_blank')} className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive h-9 has-[>svg]:px-3 text-[#0F2533] font-semibold rounded-lg px-6 py-2 transition-opacity shadow-md w-full !bg-[hsl(42,50%,70%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90 hover:opacity-90 md:w-auto">
                      Descargar brochure
                    </Button>
                  </div>
                </div>
              </div>;
        })}
        </div>

        <div className="mt-20 flex justify-center md:hidden">
          <Button asChild className="w-full bg-[#e6cd93] text-white hover:bg-[#e6cd93]/90 rounded-lg py-6 text-sm font-bold uppercase tracking-widest">
            <Link to="#">Ver todos los proyectos</Link>
          </Button>
        </div>
      </div>

      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-6">
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity duration-300" aria-hidden="true" />
          
          <div className="relative w-full max-w-4xl max-h-[95vh] bg-white rounded-lg shadow-xl overflow-y-auto flex flex-col animate-in fade-in zoom-in duration-300">
            <div className="flex items-center justify-between px-8 py-4 border-b border-gray-100">
              <h3 className="text-2xl font-bold text-[#0F2533] uppercase tracking-tight">
                {selectedProject?.title}
              </h3>
              <Button variant="ghost" size="icon" onClick={() => setIsOpen(false)} className="text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg">
                <X className="h-6 w-6" />
              </Button>
            </div>
            
            <div className="flex-1 bg-gray-50 overflow-y-auto">
              <iframe src={selectedProject?.pdfUrl} className="w-full h-[75vh] md:h-[600px]" style={{
            border: 'none'
          }} allow="fullscreen" title={`Brochure - ${selectedProject?.title}`} />
            </div>
          </div>
        </div>}
    </section>;
}